import { getFromLocalStorage } from 'utils/helpers';
import ProductsForm from './Form/Form';
import { ProductsFormHeaderTitle } from './Components';
import { DefaultFormHeaderColumn1 } from 'components/jarvisly-module/Form/FormHeader';
import ProductsParametersModal from './Parameters/ParametersModal';
import DataImportModal from './DataImport/DataImportModal';
import ProductsIndex from './Index/ProductsIndex';

// GLOBAL VARIABLES ************************************************************
// *****************************************************************************

const MODULE_ID = 'applekkusProducts';
const MODULE_API = '/v1/products';
export const PROCUCT_PARAMETERS_API = '/v1/products/parameters';


// MODULE PARAMETERS ***********************************************************
// *****************************************************************************

const PRODUCTS_MODULE = {
  id: MODULE_ID,
  noBlockScreenWithAppNotConfigured: false,
  api: MODULE_API,
  urlCustomForm: null,
  defaultUrlQueryString: null,

  components: {
    // list
    dashboard: null,
    list: props => <ProductsIndex {...props} />,
    grid: null,
    kanban: null,
    filter: null,

    // form
    form: props => <ProductsForm {...props} />,
    formHeaderTitle: props => <ProductsFormHeaderTitle {...props} />,
    formHeaderSubtitle: null,
    formHeaderColumn1: props => <DefaultFormHeaderColumn1 {...props} />,
    formHeaderColumn2: null,
    formHeaderColumn3: null,
    formHeaderTags: null,
    formHeaderCustomIcons: null,

    // module Parameters
    parameters: props => <ProductsParametersModal {...props} />,

    // module data import
    dataImport: props => <DataImportModal {...props} />,

    // data preview
    previewHeader: null,
    previewBody: null,
    previewActions: null,
  },

  methods: {
    decorateDocument,
    // canEditDocument
    // decorateParameters,
  },

  initialRequest: {
    folder: 'documents',

    folderOptions: ['documents', 'recycle', 'filed'],


    pagination: {
      pageNumber: 1, // current page
      pageSize: getFromLocalStorage('pageSize'),
    },

    paginationOptions: {
      pageSize: [10, 20, 50, 100],
    },

  },

  listState: {
    override: false,
    hideBreadcrumb: false,

    hideTitleSummary: true,
    hasFilter: true, // show the filter (folders and customs) drawer button
    hasNewOptionsButtons: true, // show options action button. p.s. if not exists 'new' action in documentState.actions, the new button will be hidden

    actions: [
      'refreshList',
      'clearSearch',
      'showLineNumbers'
    ],

    showParameters: true,
    showDataImport: false,

    initTab: null,
    viewMode: ['list'], // 'list', 'kanban', 'grid' or 'dashboard'
    showNumberOfLine: false, // show number of line in table list
    showCheckBoxes: false, // show check boxes on table list for multiple selection
    hasAccessControl: false, // show the control access modal for this module
    isTableChanged: false, // detect if the table was changed, check if the currentQs is different of initialQs (includes column sorter, search and pagination)
    isFilterChanged: false, // detect if the filters was changed
    fieldsForRegex: [],
    textSearchInDrawer: true, // inform that the textSearch field is into Drawer Filter to mark the filter button as danger (red)
    refreshDataOfList: 0,

  // filter options
    // filterInitialize: {
    //   dataProfile: dataProfile,
    //   dataType: dataType,
    // },

    filterInitialize: {
      // dataProfile: ['customer'],
      // dataType: ['person', 'company'],
    },

    // sort options
    sorterInitialize: {
      '_metadata.audit.updatedAt': -1,
    },

    sorterOrderPrecedence: [
      '_metadata.counter',
      'name',
      'status',
      '_metadata.audit.updatedAt',
    ],
  },

  documentState: {
    showParameters: true,

    disableLockForEdit: false,
    initTab: 'record',
    fieldName: 'name',
    newDocumentTitle: 'new_product',
    autoFill: false,
    actions: [
      'new',
      'edit',
      'reload',
      'divider',
      'duplicate',
      'file',
      'remove',
      'permanently_remove',
      'divider',
      'document_status',
    ],
    refreshParametersOnSave: true,
    indexes: [],

    refreshDataOfDocument: 0,
    mockDocument: {},
  },
};

// EXPORT ********************************************************************
// ***************************************************************************

export default PRODUCTS_MODULE;

// INTERNAL FUNCTIONS ========================================================
// ===========================================================================

function decorateDocument(doc) {
  // console.log('1 decorateDocument', doc?.price);
  // if (doc?.price) doc.price =  Number(doc.price).toFixed(2);
  // console.log('2 decorateDocument', Number(doc?.price));

  return doc;
}
